export function getColorAttribute(identifier: number) {
	return "#" + ("00" + identifier.toString(16)).slice(-3);
}
